// extracted by mini-css-extract-plugin
export default {"Dojo":"dojo_Dojo__qQ7nL"};